import { numberMoney, percentage } from 'Data/format.js'

export function getConfiguredDiscount(discount) {
  let setup = ''
  switch (discount?.type) {
    case 'percentage':
      setup = percentage(discount.value)
      break
    case 'amount':
      setup = numberMoney(discount.value)
      break
    default:
      break
  }

  return `Payment Plan setup ${
    !setup.length
      ? setup
      : `(${setup} discount${discount.stack ? ' stack' : ' no stack'})`
  }`
}
